import React from 'react'
import { Link } from 'react-router-dom';
import rebat from "../../Assets/images/rebat-chris.webp";

const PackageSection = () => {
    return (
        <section className="packages">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12">
                        <div className='packegLst'>
                            <div className="d-flex justify-content-between flex-column flex-md-row gap-3  align-items-center mb-4 mb-md-5">
                                <div
                                    className="sectionTitle text-center text-md-start mb-0"
                                    data-aos="fade-up"
                                    data-aos-duration={5000}
                                >
                                    <strong>Deine Fitness Pakete</strong>
                                    <p className='m-0'>Bereits für dich mit 15% reduziert</p>
                                </div>
                                <div className="chrismasrtimg"><img src={rebat}/></div>
                            </div>
                            <div className="row mt-4 mt-md-0">
                                <div className="col-sm-12 col-lg-6 mb-4">
                                    <div className="packageItem" data-aos="flip-left" data-aos-delay={500 * 1}>
                                        <form action>
                                            <div className="packageName">
                                                Platin. 12 MONATE

                                                <div className={"percentagebx discount1"}>
                                                    <div className="w-100 text-center">
                                                        <span className="numtext">35<span>%</span></span>
                                                        <p>Rabatt</p>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="packageHead">
                                                <strong>15,23€</strong><small>/Monat</small>
                                                <p>
                                                    <p><span style={{textDecoration: "line-through"}}>214,99&euro;</span> 182,74&euro; | Einmalige Abrechnung&nbsp;</p>

                                                </p>
                                            </div>
                                            <div className="packageBody">
                                                <h2>Deine Vorteile:</h2>
                                                <ul>
                                                    <li class="tick">Zugriff auf alle SHAPE Programme&nbsp;</li>
                                                    <li class="tick">Unbegrenzter Zugriff auf Sarah Time</li>
                                                    <li class="tick">SHAPE App f&uuml;r dein flexibles Training**</li>
                                                    <li class="tick">Exklusive &Uuml;berraschungen, wie Live Workouts</li>
                                                    <li class="tick">Wissenswerte Informationen&nbsp;&nbsp;</li>
                                                    <li class="tick">10% Rabatt im Shop</li>
                                                    <li class="tick">Kostenloses eBook (Wert 19.90&euro;)</li>
                                                </ul>
                                            </div>
                                            <span className="btnWrapper"><Link to={`/package-checkout/9`} className={"btn themeBTn btn1"}>JETZT DURCHSTARTEN</Link></span>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-lg-6 mb-4">
                                    <div className="packageItem" data-aos="flip-left" data-aos-delay={500 * 2}>
                                        <form action>
                                            <div className="packageName">
                                                Silber. 1 MONATE
                                            </div>
                                            <div className="packageHead">
                                                <strong>21,24€</strong><small>/Monat</small>
                                                <p>
                                                    <p><span style={{textDecoration: "line-through"}}>24,99&euro;</span> 21,24&euro; | Einmalige Abrechnung&nbsp;</p>

                                                </p>
                                            </div>
                                            <div className="packageBody">
                                                <h2>Deine Vorteile:</h2>
                                                <ul>
                                                    <li class="tick">Zugriff auf alle SHAPE Programme&nbsp;</li>
                                                    <li class="tick">Unbegrenzter Zugriff auf Sarah Time</li>
                                                    <li class="tick">SHAPE App f&uuml;r dein flexibles Training**</li>
                                                    <li class="tick">Exklusive &Uuml;berraschungen, wie Live Workouts</li>
                                                    <li class="tick">Wissenswerte Informationen&nbsp;&nbsp;</li>
                                                    <li class="cross">10% Rabatt im Shop</li>
                                                    <li class="cross">Kostenloses eBook&nbsp;(Wert 19.90&euro;)</li>
                                                </ul>

                                            </div>
                                            <span className="btnWrapper"><Link to={`/package-checkout/8`} className={"btn themeBTn btn2"}>JETZT DURCHSTARTEN</Link></span>
                                        </form>
                                    </div>
                                </div>

                                <div className="col-sm-12 packagebtnbottom">
                                    <span className="btnWrapper"><Link to={"/adventskalender"} data-bs-toggle="modal"
                                        data-bs-target="#choosePackage" className="btn themeBTn btnBlack">Jetzt 7 Tage kostenlos testen</Link></span>
                                </div>
                                {/* <small className='mt-3 text-center'>*Die Mitgliedschaft verlängert sich automatisch. Danach ist sie mit einer Frist von einem Monat jederzeit kündbar.</small> */}
                                <small className='mt-3 text-center'>*Die Mitgliedschaften verlängern sich automatisch. Nach Ablauf des Jahresabos erfolgt die Verlängerung zum regulären Monatspreis von 24,99 €. Danach können beide Mitgliedschaften jederzeit mit einer Frist von einem Monat gekündigt werden.</small>
                                {/* <small className='mt-2 text-center'>**Coming soon</small> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="modal fade packagemodal packagepkmodal"
                id="choosePackage"
                tabindex="-1"
                aria-labelledby="choosePackageLabel"
                aria-hidden="true"
            >
                <div
                    class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="choosePackageLabel">
                                Wähle dein Paket:
                            </h5>
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body">
                            <div className="packegLst">
                                <div className="row justify-content-center">
                                    <div className="col-sm-12 col-lg-4 mb-4">
                                        <div className="packageItem" data-aos="flip-left" data-aos-delay={500 * 1}>
                                            <form action>
                                                <div className="packageName">
                                                    Platin. 12 MONATE

                                                    <div className={"percentagebx discount1"}>
                                                        <div className="w-100 text-center">
                                                            <span className="numtext">35<span>%</span></span>
                                                            <p>Rabatt</p>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="packageHead">
                                                    <strong>15,23€</strong><small>/Monat</small>
                                                    <p>
                                                        <p><span style={{textDecoration: "line-through"}}>214,99&euro;</span> 182,74&euro; | Einmalige Abrechnung&nbsp;</p>

                                                    </p>
                                                </div>
                                                <div className="packageBody">
                                                    <h2>Deine Vorteile:</h2>
                                                    <ul>
                                                        <li class="tick">Zugriff auf alle SHAPE Programme&nbsp;</li>
                                                        <li class="tick">Unbegrenzter Zugriff auf Sarah Time</li>
                                                        <li class="tick">SHAPE App f&uuml;r dein flexibles Training**</li>
                                                        <li class="tick">Exklusive &Uuml;berraschungen, wie Live Workouts</li>
                                                        <li class="tick">Wissenswerte Informationen&nbsp;&nbsp;</li>
                                                        <li class="tick">10% Rabatt im Shop</li>
                                                        <li class="tick">Kostenloses eBook (Wert 19.90&euro;)</li>
                                                    </ul>
                                                </div>
                                                <span className="btnWrapper"><Link to={`/package-checkout/9`} className={"btn themeBTn btn1"}>JETZT DURCHSTARTEN</Link></span>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-4 mb-4">
                                        <div className="packageItem" data-aos="flip-left" data-aos-delay={500 * 2}>
                                            <form action>
                                                <div className="packageName">
                                                    Silber. 1 MONATE
                                                </div>
                                                <div className="packageHead">
                                                    <strong>21,24€</strong><small>/Monat</small>
                                                    <p>
                                                        <p><span style={{textDecoration: "line-through"}}>24,99&euro;</span> 21,24&euro; | Einmalige Abrechnung&nbsp;</p>

                                                    </p>
                                                </div>
                                                <div className="packageBody">
                                                    <h2>Deine Vorteile:</h2>
                                                    <ul>
                                                        <li class="tick">Zugriff auf alle SHAPE Programme&nbsp;</li>
                                                        <li class="tick">Unbegrenzter Zugriff auf Sarah Time</li>
                                                        <li class="tick">SHAPE App f&uuml;r dein flexibles Training**</li>
                                                        <li class="tick">Exklusive &Uuml;berraschungen, wie Live Workouts</li>
                                                        <li class="tick">Wissenswerte Informationen&nbsp;&nbsp;</li>
                                                        <li class="cross">10% Rabatt im Shop</li>
                                                        <li class="cross">Kostenloses eBook&nbsp;(Wert 19.90&euro;)</li>
                                                    </ul>

                                                </div>
                                                <span className="btnWrapper"><Link to={`/package-checkout/8`} className={"btn themeBTn btn2"}>JETZT DURCHSTARTEN</Link></span>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PackageSection